// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Services Page Styling - Kubersetu Infotech
   ========================================== */

.services-page {
  padding-top: 7.25rem;
  padding-bottom: 5rem;
}

.services-filter-tabs {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
  flex-wrap: wrap;
}

.filter-tab {
  background: rgba(15, 23, 42, 0.7);
  border: 1px solid var(--border-bento);
  color: var(--text-muted);
  font-weight: 700;
  font-size: 0.95rem;
  padding: 0.75rem 1.75rem;
  border-radius: var(--radius-pill);
  cursor: pointer;
  transition: all 0.3s ease;
}

.filter-tab:hover, .filter-tab.active {
  background: var(--color-amber);
  color: #0F172A;
  border-color: var(--color-amber);
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);
}

.services-bento-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  width: 100%;
}

@media (min-width: 1200px) {
  .services-bento-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.service-bento-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 1.85rem 1.6rem;
  background: rgba(18, 24, 38, 0.8) !important;
  border: 1px solid rgba(255, 255, 255, 0.09) !important;
  border-radius: 18px !important;
  box-sizing: border-box;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25) !important;
  position: relative;
  overflow: hidden;
}

.service-bento-card:hover {
  transform: translateY(-4px) !important;
  border-color: rgba(245, 158, 11, 0.4) !important;
  box-shadow: 0 12px 30px -8px rgba(0, 0, 0, 0.5), 0 0 20px rgba(245, 158, 11, 0.15) !important;
  background: rgba(22, 30, 48, 0.9) !important;
}

.service-card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.service-icon,
.service-card-icon {
  font-size: 1.5rem;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  line-height: 1;
}

.service-tag,
.service-card-tag {
  font-size: 0.68rem;
  font-weight: 700;
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.25);
  padding: 0.3rem 0.75rem;
  border-radius: 20px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
}

.service-card-tag.tech-tag {
  color: #38BDF8;
  background: rgba(56, 189, 248, 0.12);
  border-color: rgba(56, 189, 248, 0.3);
}

.service-card-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.75rem;
  line-height: 1.35;
  letter-spacing: -0.01em;
  word-break: break-word;
}

.service-card-desc {
  color: #94a3b8;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.25rem;
  flex: 1 1;
}

.service-highlights,
.service-highlights-list {
  list-style: none;
  padding: 1rem 0;
  margin: 0 0 1.5rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: transparent !important;
  border-radius: 0 !important;
  box-sizing: border-box;
}

.service-highlights li,
.service-highlights-list li {
  font-size: 0.88rem;
  color: #cbd5e1;
  line-height: 1.45;
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
}

.service-highlights .check-icon,
.service-highlights-list .check-icon {
  color: #f59e0b;
  font-weight: 800;
  font-size: 0.92rem;
  line-height: 1.2;
  flex-shrink: 0;
}

.service-cta-btn {
  width: 100%;
  text-align: center;
  justify-content: center;
  padding: 0.8rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #0f172a !important;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  border: none !important;
  border-radius: 12px !important;
  white-space: nowrap;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  line-height: 1.2;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.2) !important;
}

.service-cta-btn:hover {
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%) !important;
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.35) !important;
  transform: translateY(-2px) !important;
}

.btn-tech-action {
  background: linear-gradient(135deg, #0284C7 0%, #38BDF8 100%);
  color: #ffffff;
  font-weight: 800;
  box-shadow: 0 4px 15px rgba(56, 189, 248, 0.3);
}

.btn-tech-action:hover {
  box-shadow: 0 6px 20px rgba(56, 189, 248, 0.5);
  color: #ffffff;
  transform: translateY(-2px);
}

.tech-badge-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem;
}

.tech-badge {
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid var(--border-bento);
  color: #ffffff;
  font-weight: 700;
  font-size: 0.9rem;
  padding: 0.6rem 1.25rem;
  border-radius: var(--radius-pill);
  transition: all 0.3s ease;
}

.tech-badge:hover {
  border-color: var(--color-amber);
  transform: translateY(-2px);
  color: var(--color-amber);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Services.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;EACjC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,4CAA4C;EAC5C,sDAAsD;EACtD,8BAA8B;EAC9B,sBAAsB;EACtB,6DAA6D;EAC7D,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,6FAA6F;EAC7F,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,0CAA0C;EAC1C,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,SAAO;AACT;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+CAA+C;EAC/C,kDAAkD;EAClD,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,wEAAwE;EACxE,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,yDAAyD;AAC3D;;AAEA;EACE,wEAAwE;EACxE,0DAA0D;EAC1D,sCAAsC;AACxC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,yBAAyB;AAC3B","sourcesContent":["/* ==========================================\n   Services Page Styling - Kubersetu Infotech\n   ========================================== */\n\n.services-page {\n  padding-top: 7.25rem;\n  padding-bottom: 5rem;\n}\n\n.services-filter-tabs {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 2rem;\n  flex-wrap: wrap;\n}\n\n.filter-tab {\n  background: rgba(15, 23, 42, 0.7);\n  border: 1px solid var(--border-bento);\n  color: var(--text-muted);\n  font-weight: 700;\n  font-size: 0.95rem;\n  padding: 0.75rem 1.75rem;\n  border-radius: var(--radius-pill);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.filter-tab:hover, .filter-tab.active {\n  background: var(--color-amber);\n  color: #0F172A;\n  border-color: var(--color-amber);\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);\n}\n\n.services-bento-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  width: 100%;\n}\n\n@media (min-width: 1200px) {\n  .services-bento-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.service-bento-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  padding: 1.85rem 1.6rem;\n  background: rgba(18, 24, 38, 0.8) !important;\n  border: 1px solid rgba(255, 255, 255, 0.09) !important;\n  border-radius: 18px !important;\n  box-sizing: border-box;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25) !important;\n  position: relative;\n  overflow: hidden;\n}\n\n.service-bento-card:hover {\n  transform: translateY(-4px) !important;\n  border-color: rgba(245, 158, 11, 0.4) !important;\n  box-shadow: 0 12px 30px -8px rgba(0, 0, 0, 0.5), 0 0 20px rgba(245, 158, 11, 0.15) !important;\n  background: rgba(22, 30, 48, 0.9) !important;\n}\n\n.service-card-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.25rem;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.service-icon,\n.service-card-icon {\n  font-size: 1.5rem;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  line-height: 1;\n}\n\n.service-tag,\n.service-card-tag {\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #f59e0b;\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.25);\n  padding: 0.3rem 0.75rem;\n  border-radius: 20px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.service-card-tag.tech-tag {\n  color: #38BDF8;\n  background: rgba(56, 189, 248, 0.12);\n  border-color: rgba(56, 189, 248, 0.3);\n}\n\n.service-card-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 0.75rem;\n  line-height: 1.35;\n  letter-spacing: -0.01em;\n  word-break: break-word;\n}\n\n.service-card-desc {\n  color: #94a3b8;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  margin-bottom: 1.25rem;\n  flex: 1;\n}\n\n.service-highlights,\n.service-highlights-list {\n  list-style: none;\n  padding: 1rem 0;\n  margin: 0 0 1.5rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: transparent !important;\n  border-radius: 0 !important;\n  box-sizing: border-box;\n}\n\n.service-highlights li,\n.service-highlights-list li {\n  font-size: 0.88rem;\n  color: #cbd5e1;\n  line-height: 1.45;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.55rem;\n}\n\n.service-highlights .check-icon,\n.service-highlights-list .check-icon {\n  color: #f59e0b;\n  font-weight: 800;\n  font-size: 0.92rem;\n  line-height: 1.2;\n  flex-shrink: 0;\n}\n\n.service-cta-btn {\n  width: 100%;\n  text-align: center;\n  justify-content: center;\n  padding: 0.8rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #0f172a !important;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;\n  border: none !important;\n  border-radius: 12px !important;\n  white-space: nowrap;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.2) !important;\n}\n\n.service-cta-btn:hover {\n  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%) !important;\n  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.35) !important;\n  transform: translateY(-2px) !important;\n}\n\n.btn-tech-action {\n  background: linear-gradient(135deg, #0284C7 0%, #38BDF8 100%);\n  color: #ffffff;\n  font-weight: 800;\n  box-shadow: 0 4px 15px rgba(56, 189, 248, 0.3);\n}\n\n.btn-tech-action:hover {\n  box-shadow: 0 6px 20px rgba(56, 189, 248, 0.5);\n  color: #ffffff;\n  transform: translateY(-2px);\n}\n\n.tech-badge-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.75rem;\n}\n\n.tech-badge {\n  background: rgba(15, 23, 42, 0.8);\n  border: 1px solid var(--border-bento);\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 0.9rem;\n  padding: 0.6rem 1.25rem;\n  border-radius: var(--radius-pill);\n  transition: all 0.3s ease;\n}\n\n.tech-badge:hover {\n  border-color: var(--color-amber);\n  transform: translateY(-2px);\n  color: var(--color-amber);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
